import React, { useEffect, useState } from "react";
import Navbar from "../Navbar/Navbar";
import { Container, Row, Col, Card, Button } from "react-bootstrap";
import "./ConfirmationPage.css";
import SuccessIcon from "./../../Assets/Icons/success.png";
import FailIcon from "./../../Assets/Icons/cross-sign.png";
import AdLogo from "./../../Assets/Icons/Go5050.png";
import { useLocation, useNavigate } from "react-router-dom";
import Footer from "../../components/Footer/Footer";
import axios from "axios";
import { toast } from "react-toastify";
import { decreaseItemCount } from "../../reducers/cartCounterReducer";
import { useDispatch } from "react-redux";

const ConfirmationPage = () => {
  const location = useLocation();
  const [blur, setBlur] = useState(false);
  const [isChecked, setIsChecked] = useState("loading");
  const [checkResponse, setCheckResponse] = useState(null);
  const [paymentId, setPaymentId] = useState(null);
  const [gotResult, setGotResult] = useState(false);
  const navigate = useNavigate();

  const dispatch = useDispatch();

  const searchDialogOpen = (NavbarData) => {
    setBlur(NavbarData);
  };

  useEffect(() => {
    const sendOrderFromLocalStorage = async () => {
      try {
        const searchParams = new URLSearchParams(location.search);
        const id = searchParams.get("id");
        const resourcePath = searchParams.get("resourcePath");
        console.log("Search Params:", searchParams.toString());
        if (id && resourcePath) {
          console.log("Checkout ID:", id);
          console.log("Resource Path:", decodeURIComponent(resourcePath));
          const savedData = localStorage.getItem("lastOrderData");

          const checkoutRaw = localStorage.getItem("checkoutDetails");

          if (!savedData) {
            console.warn("No saved order data found in localStorage.");
            return;
          }

          if (!checkoutRaw) {
            console.error("checkoutDetails not found in localStorage.");
            return;
          }

          const checkoutData = JSON.parse(checkoutRaw);

          const parsedData = JSON.parse(savedData);
          const { confirmedOrders, paymentDetails } = parsedData;

          // Send ConfirmOrders API
          const confirmRes = await axios.post(
            `${process.env.REACT_APP_SECRET}/api/Order/ConfirmOrders`,
            confirmedOrders
          );
          console.log("ConfirmOrders response:", confirmRes.data);

          const paymentDetailsWithCheckout = paymentDetails.map((payment) => {
            const id = payment.id ?? crypto.randomUUID();
            const orderId = payment.orderId ?? "";
            const totalAmount = payment.totalAmount ?? 0;
            const totalVAT = payment.totalVAT ?? 0;
            const totalSD = payment.totalSD ?? 0;
            const totalTips = payment.totalTips ?? 0;
            const totalServiceCharge = payment.totalServiceCharge ?? 0;
            const totalServiceChargeVat = payment.totalServiceChargeVat ?? 0; // Add service charge VAT
            const totalCreditGivenToCust = payment.totalCreditGivenToCust ?? 0;
            const platformFeeId = payment.platformFeeId ?? 0;
            const totalPlatformFees = payment.totalPlatformFees ?? 0;
            const totalProcessingFees = payment.totalProcessingFees ?? 0;
            const totalCaptureFees = payment.totalCaptureFees ?? 0;
            const totalAuthFees = payment.totalAuthFees ?? 0;
            const orderStatusId = payment.orderStatusId ?? "";
            const creationId = payment.creationId ?? "";

            const paidPaymentDetails = {
              id: payment.paidPaymentDetails?.id ?? crypto.randomUUID(),
              orderPaymentId: id,
              paidAmount: payment.paidPaymentDetails?.paidAmount ?? 0,
              remainingAmount: payment.paidPaymentDetails?.remainingAmount ?? 0,
              paymentDate:
                payment.paidPaymentDetails?.paymentDate ??
                new Date().toISOString(),
              paymentTypeId: payment.paidPaymentDetails?.paymentTypeId ?? "",
            };

            const checkout = {
              id: crypto.randomUUID(),
              orderPaymentId: id,
              resultCode: checkoutData.result?.code ?? "",
              resultDescription: checkoutData.result?.description ?? "",
              buildNumber: checkoutData.buildNumber ?? "",
              timestampUtc: new Date(checkoutData.timestamp),
              ndc: checkoutData.ndc ?? "",
              transactionId: checkoutData.id ?? "",
              integrityHash: checkoutData.integrity ?? "",
              createdAt: new Date().toISOString(),
              paymentId: paymentId || null,
            };

            return {
              id,
              orderId,
              totalAmount,
              totalVAT,
              totalSD,
              totalTips,
              totalServiceCharge,
              totalServiceChargeVat, // Add service charge VAT to the API payload
              totalCreditGivenToCust,
              platformFeeId,
              totalPlatformFees,
              totalProcessingFees,
              totalCaptureFees,
              totalAuthFees,
              orderStatusId,
              creationId,
              paidPaymentDetails,
              checkout,
            };
          });

          // Send payment data
          const paymentResponses = await Promise.all(
            paymentDetailsWithCheckout.map((payment) =>
              axios.post(
                `${process.env.REACT_APP_SECRET}/api/Order/InsertOrderPayment`,
                payment
              )
            )
          );
          console.log(
            "Payment responses:",
            paymentResponses.map((res) => res.data)
          );
          toast.success("Order and payment data successfully sent.");
        } else {
          console.warn("Missing ID or resourcePath in URL.");
          toast.error("Invalid confirmation link.");
        }

        // Clear after successful submission
        localStorage.removeItem("lastOrderData");
      } catch (error) {
        console.error("Error sending order/payment data:", error);
        toast.error("Failed to send order/payment data.");
      }
    };

    if (isChecked == "Success") {
      sendOrderFromLocalStorage();
    }
  }, [isChecked]);

  // useEffect(() => {
  //   const checkoutRaw = localStorage.getItem("checkoutDetails");
  //   if (!checkoutRaw) {
  //     console.error("checkoutDetails not found in localStorage.");
  //     return;
  //   }

  //   const checkoutData = JSON.parse(checkoutRaw);
  //   const refId = checkoutData.ndc;

  //   const isLocalDev =
  //     process.env.NODE_ENV === "development" &&
  //     window.location.hostname === "localhost";

  //   // if (isLocalDev) {
  //   //   console.log(
  //   //     "Running in local development. Skipping payment status check."
  //   //   );
  //   //   setIsChecked("Success");
  //   //   return;
  //   // }

  //   const handleCheckCurrentPaymentStatus = async () => {
  //     try {
  //       const response = await axios.get(
  //         `${process.env.REACT_APP_SECRET}/api/Payment/CheckCurrentPaymentStatus?checkoutId=${refId}`
  //       );

  //       console.log("CheckCurrentPaymentStatus Response:", response.data);

  //       const resultCode = response.data?.result?.code;

  //       if (
  //         resultCode === "000.100.110" ||
  //         resultCode === "000.100.112" ||
  //         resultCode === "000.000.000" ||
  //         resultCode === "000.000.100"
  //       ) {
  //         setIsChecked("Success");
  //         setPaymentId(response.data?.id || null);
  //         setCheckResponse({
  //           paymentStatusDetails:
  //             response.data?.result?.description || "Payment successful.",
  //         });
  //         setGotResult(true);
  //         return true;
  //       } else if (resultCode === "000.200.000") {
  //         setIsChecked("loading");
  //         setCheckResponse({
  //           paymentStatusDetails:
  //             response.data?.result?.description ||
  //             "Payment is still processing. Please wait.",
  //         });
  //         setGotResult(true);
  //         return true;
  //       } else {
  //         setIsChecked("Failed");
  //         setCheckResponse({
  //           paymentStatusDetails:
  //             response.data?.result?.description || "Unknown error",
  //         });
  //         setGotResult(true);
  //         return true;
  //       }
  //     } catch (error) {
  //       if (axios.isAxiosError(error) && error.response?.status === 400) {
  //         console.warn("CheckCurrentPaymentStatus returned 400. Falling back.");
  //         return false;
  //       } else {
  //         console.error("Error calling CheckCurrentPaymentStatus:", error);
  //         setIsChecked("Failed");
  //         return true;
  //       }
  //     }
  //   };

  //   const checkOrderStatusFallback = async (retryCount = 0) => {
  //     try {
  //       const response = await axios.get(
  //         `${process.env.REACT_APP_SECRET}/api/Order/OrderPaymentAttemptsStatusCheck?refId=${refId}`
  //       );

  //       console.log(
  //         "Fallback OrderPaymentAttemptsStatusCheck Response:",
  //         response.data
  //       );
  //       setCheckResponse(response.data);

  //       const { paymentStatus } = response.data;

  //       if (paymentStatus === "Success") {
  //         setIsChecked("Success");
  //       } else if (paymentStatus === "Failed") {
  //         setIsChecked("Failed");
  //       } else if (paymentStatus === "Pending" && retryCount < 15) {
  //         setTimeout(() => checkOrderStatusFallback(retryCount + 1), 3000);
  //       } else {
  //         setIsChecked("Failed");
  //       }
  //     } catch (error) {
  //       console.error("Error checking fallback payment status:", error);
  //       setIsChecked("Failed");
  //     }
  //   };

  //   const checkStatus = async () => {
  //     const handled = await handleCheckCurrentPaymentStatus();
  //     console.log("Payment status check handled:", handled);
  //     if (!handled && isChecked !== "Success") {
  //       checkOrderStatusFallback();
  //     }
  //   };
  //   console.log("Initial paymentId:", paymentId);
  //   console.log("Initial isChecked:", isChecked);
  //   console.log("Initial gotResult:", gotResult);
  //   if (isChecked == "loading" && paymentId === null && !gotResult) {
  //     console.log("Starting payment status check...", isChecked);
  //     checkStatus();
  //   }
  // }, []);

  useEffect(() => {
    const hasRun = window.__paymentCheckHasRun;
    if (hasRun) return;
    window.__paymentCheckHasRun = true;

    const checkoutRaw = localStorage.getItem("checkoutDetails");
    if (!checkoutRaw) {
      console.error("checkoutDetails not found in localStorage.");
      return;
    }

    const checkoutData = JSON.parse(checkoutRaw);
    const refId = checkoutData.ndc;

    const handleCheckCurrentPaymentStatus = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_SECRET}/api/Payment/CheckCurrentPaymentStatus?checkoutId=${refId}`
        );

        console.log("CheckCurrentPaymentStatus Response:", response.data);

        const resultCode = response.data?.result?.code;

        if (
          resultCode === "000.100.110" ||
          resultCode === "000.100.112" ||
          resultCode === "000.000.000" ||
          resultCode === "000.000.100"
        ) {
          setIsChecked("Success");
          setPaymentId(response.data?.id || null);
          setCheckResponse({
            paymentStatusDetails:
              response.data?.result?.description || "Payment successful.",
          });
          setGotResult(true);
          return true;
        } else if (resultCode === "000.200.000") {
          setIsChecked("loading");
          setCheckResponse({
            paymentStatusDetails:
              response.data?.result?.description ||
              "Payment is still processing. Please wait.",
          });
          setGotResult(true);
          return true;
        } else {
          setIsChecked("Failed");
          setCheckResponse({
            paymentStatusDetails:
              response.data?.result?.description || "Unknown error",
          });
          setGotResult(true);

          return true;
        }
      } catch (error) {
        if (axios.isAxiosError(error) && error.response?.status === 400) {
          console.warn("CheckCurrentPaymentStatus returned 400. Falling back.");
          return false;
        } else {
          console.error("Error calling CheckCurrentPaymentStatus:", error);
          setIsChecked("Failed");
          return true;
        }
      }
    };

    const checkOrderStatusFallback = async (retryCount = 0) => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_SECRET}/api/Order/OrderPaymentAttemptsStatusCheck?refId=${refId}`
        );

        console.log(
          "Fallback OrderPaymentAttemptsStatusCheck Response:",
          response.data
        );
        setCheckResponse(response.data);

        const { paymentStatus } = response.data;

        if (paymentStatus === "Success") {
          setIsChecked("Success");
        } else if (paymentStatus === "Failed") {
          setIsChecked("Failed");
        } else if (paymentStatus === "Pending" && retryCount < 15) {
          setTimeout(() => checkOrderStatusFallback(retryCount + 1), 3000);
        } else {
          setIsChecked("Failed");
        }
      } catch (error) {
        console.error("Error checking fallback payment status:", error);
        setIsChecked("Failed");
      }
    };

    const checkStatus = async () => {
      const handled = await handleCheckCurrentPaymentStatus();
      console.log("Payment status check handled:", handled);
      if (!handled && isChecked !== "Success") {
        checkOrderStatusFallback();
      }
    };

    if (isChecked === "loading" && paymentId === null && !gotResult) {
      console.log("Starting payment status check...", isChecked);
      checkStatus();
    }
  }, []);

  useEffect(() => {
    if (isChecked === "Success") {
      dispatch(decreaseItemCount(1));
    }
  }, [isChecked]);

  return (
    <div>
      <Navbar handleNavbar={searchDialogOpen} />

      {isChecked === "loading" && (
        <Container className='mt-5 text-center'>
          <Row className='justify-content-center'>
            <Col xs={12} md={8} lg={6}>
              <Card className='text-center p-5 shadow-sm border-0'>
                <Card.Body>
                  <div className='d-flex justify-content-center mb-3'>
                    <div
                      className='spinner-border text-primary'
                      role='status'
                      style={{ width: "3rem", height: "3rem" }}
                    >
                      <span className='visually-hidden'>Loading...</span>
                    </div>
                  </div>
                  <Card.Title className='fs-5'>
                    Checking your payment status...
                  </Card.Title>
                  <Card.Text className='text-muted'>
                    Please wait a moment while we verify your order.
                  </Card.Text>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </Container>
      )}

      {isChecked === "Success" && (
        <Container className='mt-lg-5'>
          <Row className='justify-content-center'>
            <Col xs={12} md={8} lg={6}>
              <Card className='text-center p-4 shadow-lg cardContainer border-success'>
                {/* Success Icon */}
                <img
                  className='w-25 mx-auto mb-3'
                  src={SuccessIcon}
                  alt='Success'
                />

                <Card.Title className='text-success fs-4 fw-bold'>
                  Order Successful
                </Card.Title>

                <Card.Text className='text-muted mt-2'>
                  Thank you so much for your order.
                </Card.Text>

                <div
                  className='d-flex align-items-center justify-content-center px-3 py-2 bg-light rounded border border-secondary-subtle'
                  style={{ fontSize: "0.75rem" }}
                >
                  <img
                    src={AdLogo}
                    alt='Ad Logo'
                    style={{
                      width: "30px",
                      height: "30px",
                      objectFit: "contain",
                      marginRight: "10px",
                    }}
                  />
                  <div className='text-start'>
                    <a href='https://go5050.co.uk/'>
                      <span className='fw-semibold text-primary'>
                        GO5050.CO.UK
                      </span>
                    </a>{" "}
                    <br />
                    <span className='text-dark'>
                      Save 80% on Netflix, Spotify, YouTube, PureGym
                    </span>
                  </div>
                </div>

                {/* CTA Button */}
                <Button
                  variant='success'
                  className='w-50 mx-auto mt-4'
                  onClick={() => navigate("/checkout?for=pending")}
                >
                  Check Status
                </Button>
              </Card>
            </Col>
          </Row>
        </Container>
      )}

      {isChecked === "Failed" && (
        <Container className='mt-lg-5'>
          <Row className='justify-content-center'>
            <Col xs={12} md={8} lg={6}>
              <Card className='text-center p-4 shadow-lg border-danger cardContainer'>
                <img
                  className='w-25 mx-auto mb-3'
                  src={FailIcon} // ✅ Ensure FailIcon is properly imported
                  alt='Order Failed'
                />
                <Card.Title className='text-danger fs-4 fw-bold'>
                  Order Failed
                </Card.Title>
                <Card.Text className='mt-3 text-muted'>
                  We’re sorry, there was a problem processing your order.
                </Card.Text>
                {checkResponse?.paymentStatusDetails && (
                  <Card.Text className='text-danger small'>
                    <strong>Reason:</strong>{" "}
                    {checkResponse.paymentStatusDetails}
                  </Card.Text>
                )}
                <Button
                  variant='danger'
                  className='w-50 mx-auto mt-3'
                  onClick={() => navigate("/checkout")}
                >
                  Try Again
                </Button>
              </Card>
            </Col>
          </Row>
        </Container>
      )}

      <Footer />
    </div>
  );
};

export default ConfirmationPage;
